import React from 'react'
import { withTranslation } from 'react-i18next'
import { LockSimpleOpen, LockSimple, CheckSquare } from "phosphor-react"
import PropTypes from 'prop-types'

class StudyCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            link: `/course/${this.props.courseId}/mod/${this.props.id}`,
        }
        this.routeToLesson = this.routeToLesson.bind(this)
    }

    routeToLesson(modId) {
        const item = document.querySelector(`#${modId}`)
        if (item.classList.contains('available') && Number(this.props.props.props.match.params.modId) !== this.props.id) {
            this.props.props.props.history.push(this.state.link)
            window.location.reload()
        }
    }

    render() {
        // const { t } = this.props
        return (
            <div className={`lesson-dropdown-item ${this.props.available ? "available" : ""} ${this.props.active ? 'active' : ''}`} id={`mod-id-${this.props.id}`} onClick={() => this.routeToLesson(`mod-id-${this.props.id}`)}>
                {this.props.active ? <div className='lesson-border'></div> : ''}
                <div className={`text xs-font-size ${this.props.available ? "active" : ""}`}>{this.props.index}. {this.props.title}</div>
                <div className="icon">
                    {
                        this.props.available ?
                            this.props.complete ? <CheckSquare size={20} color="#0B7402" />
                                : <LockSimpleOpen size={20} color="#0B7402" />
                            : <LockSimple size={20} color="#CC2B21" />
                    }


                </div>
            </div>
        )
    }
}

StudyCard.propTypes = {
    t: PropTypes.func,
    title: PropTypes.string,
    available: PropTypes.bool,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    props: PropTypes.object,
    courseId: PropTypes.string,
    active: PropTypes.bool,
    index: PropTypes.number,
    complete: PropTypes.bool,
}

export default withTranslation()(StudyCard)



// WEBPACK FOOTER //
// ./src/components/Study/LessonsDropdown.jsx